// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".recurring-events-content[data-v-54a34c32] {\n  max-height: 300px;\n  overflow-x: hidden;\n  overflow-y: scroll;\n}\n.recurringEventsListElement[data-v-54a34c32] {\n  height: 35px;\n  padding-top: 5px;\n}\n.eventTarget[data-v-54a34c32] {\n  background-color: #f9d7da;\n  font-weight: bold;\n  border: 1px solid #f5c6cb;\n}\n", ""]);
// Exports
module.exports = exports;
